module.exports = __webpack_public_path__ + "static/media/company_team.289c9b7d.jpg";